// attachment model is used only to display items in the grid.
// uploader is used to add items automatically based on the configuration.
import { Component, OnInit, Output, EventEmitter, Injector, SimpleChanges, Input, OnChanges, Inject } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders, FileUploaderOptions } from 'ng2-file-upload';
import { AttachmentResponse } from 'src/app/shared/model/attachment-response.model';
import { BaseComponent } from 'src/app/base/base.component';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';
import { saveAs as importedSaveAs } from 'file-saver-es';
import { AuthService } from 'src/app/services/user/auth.service';
import { IAppConfig } from 'src/app/services/Config/app-config.model';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent extends BaseComponent implements OnInit, OnChanges {
  public uploader: FileUploader;
  URL: string;
  attachmentsModel: AttachmentResponse[] = [];
  @Output() attachmentsUploadedResponse: EventEmitter<AttachmentResponse> = new EventEmitter<AttachmentResponse>();
  message: string;
  showMessage: boolean = false;
  messageClass: string;
  uploadedItemsCount: number = 0;
  @Input() submittalId: string;
  public hasBaseDropZoneOver: boolean = false;
  progressBarValue = 0;
  public showProgressBar = false;
  subscription: Subscription;

  constructor(public _injector: Injector,
    private _attachmentService: AttachmentsService, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
    const authService = _injector.get(AuthService);
    this.uploader = new FileUploader({
      url: this.URL,
      maxFileSize: 100 * 1024 * 1024,
      headers: [{
        name: 'x-api-key', value:
          this.configParam.ApiConfig.ATTACHMENT_API_KEY
      }]
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {
    super.ngOnInit();

    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
      this.onBeforeUploadItem(item);
    };

    this.uploader.onSuccessItem = (item, response, status, headers) => {
      this.onSuccess(item, response, status, headers);
    };

    this.uploader.onErrorItem = (item, response, status, headers) => {
      this.onError(item, response, status, headers);
    };

    this.uploader.onCompleteAll = () => {
      this._attachmentService.isAttachmentsSavedToDb = true;
    };

    this._attachmentService.getAttachments()
      .subscribe((resp: AttachmentResponse[]) => {
        this.attachmentsModel = resp;
        this.uploadedItemsCount = this.attachmentsModel.length;
      });
  }

  onError(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    if (response !== '') {
      const parsedResponse = JSON.parse(response);
    }

    this.toggleMessage('Attachment Upload Failed. Please contact System Administrator.', true, false);

    item.isUploaded = false;
  }

  onSuccess(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    const parsedResponse = JSON.parse(response);
    const attachmentResponse = new AttachmentResponse();
    Object.assign(attachmentResponse, parsedResponse.length > 0 ? parsedResponse[0] : {});
    this.attachmentsModel.forEach(attachment => {
      if ((attachment.attachmentId === null || attachment.attachmentId === undefined)
        && attachment.fileName === parsedResponse[0].FileName) {
        attachment.attachmentId = parsedResponse[0].AttachmentId;
        attachment.uploadedDate = parsedResponse[0].UploadedDate;
      }
    });

    this.updateAttachmentsFlag();
    this.toggleMessage('Attachment(s) Uploaded Successfully', true, true);
  }

  onBeforeUploadItem(item: FileItem) {
    this.toggleMessage('Attachment(s) uploading...', true, true, false);
  }

  updateAttachmentsFlag() {
    if (this.uploader.queue.length === 0) {
      this._attachmentService.isAttachmentsSavedToDb = true;
    }

    if (this.uploader.queue.length > 0) {
      this._attachmentService.isAttachmentsSavedToDb = false;
    }
  }

  toggleMessage(message: string, showMessage: boolean, isSuccess: boolean, dismissOnTimeout: boolean = true): void {
    this.message = message;
    this.showMessage = showMessage;
    this.messageClass = isSuccess ? 'alert alert-success' : 'alert alert-danger';

    if (dismissOnTimeout) {
      setTimeout(x => this.showMessage = false, 5000);
    }
  }

  // this method is used to save files to database and display it in the grid.
  uploadFiles() {
    if (this.uploader.options.url) {
      this.uploadedItemsCount = 0;
      this.uploader.queue.forEach(item => {
        this.uploadedItemsCount++;
        item.upload();
        if (this.uploader.queue.length === this.uploadedItemsCount) {
          this.toggleMessage('Uploading Attachment(s)', true, true);
        }
      });
    }
  }

  fileUploaded($event: any): void {
    this.addFileToAttachmentsModel();
  }

  // Once we upload file, it should be displayed in grid. Its used for that purpose. But not saved to database.
  addFileToAttachmentsModel() {
    this.attachmentsModel.forEach((i: AttachmentResponse, index, object) => {
      if (!i.uploadedDate) {
        object.splice(index, 1);
      }
    });

    this.uploader.queue.forEach((x: any) => {
      x.options.removeAfterUpload = true;
      const attResponse = new AttachmentResponse();
      attResponse.fileName = x.file.name;
      attResponse.size = x.file.size;

      this.attachmentsModel.push(attResponse);
    });

    this.updateAttachmentsFlag();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

    // this.uploadFiles();
    this.addFileToAttachmentsModel();
  }

  downloadAttachment(fileServiceId: string): void {
    if (this.showProgressBar == false) {
      this.ShowProgressBar();
      this.showProgress();
      this._attachmentService.getAttachment(fileServiceId)
        .subscribe(response => {
          const attachment = this.attachmentsModel.find(item => item.fileServiceId === fileServiceId);
          importedSaveAs(response, attachment.fileName);
          this.HideProgressBar();
        }, error => {
          this.toggleMessage('Error downloading attachment. Please contact System Administrator.', true, false);
          this.HideProgressBar();
        });
    }
  }

  private HideProgressBar() {
    this.progressBarValue = 100;
    this.showProgressBar = false;
    this.subscription.unsubscribe();
  }

  private ShowProgressBar() {
    this.showProgressBar = true;
    this.progressBarValue = 20;
    // emit value in sequence every 1 second
    const source = interval(1000);
    this.subscription = source.subscribe(val => this.IncreaseProgressValue(1));
  }

  IncreaseProgressValue(value: number): void {
    this.progressBarValue = this.progressBarValue + value;
    if (this.progressBarValue > 99)
      this.progressBarValue = 20;
  }
}
